module.exports = __webpack_public_path__ + "static/img/doItem1.e15af86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile_images/doItem1.png
// module id = BlLK
// module chunks = 1